const accordion = (acc, firstItemActive = false, closeOthers = true) => {
    if (!acc) return;

    const slideUp = (el, siblingEl) => {
        const content = el.querySelector(`${siblingEl}`);
        if (content) {
            el.classList.remove('active');
            content.style.maxHeight = null;
        }
    }

    const slideDown = (el, siblingEl) => {
        const content = el.querySelector(`${siblingEl}`);
        if (content) {
            el.classList.add('active');
            content.style.maxHeight = content.scrollHeight + 'px';
        }
    }

    if (firstItemActive) {
        slideDown(acc.querySelector('.tjc-acc-item'), '.tjc-acc-item--text');
    }

    function accLogic(target) {
        const items = acc.querySelectorAll('.tjc-acc-item');
        const item = target.closest('.tjc-acc-item');

        // Only close others if the closeOthers option is true
        if (closeOthers) {
            for (const otherItems of items) {
                if (otherItems !== item) {
                    slideUp(otherItems, '.tjc-acc-item--text');
                }
            }
        }

        // Toggle the clicked item
        if (item.classList.contains('active')) {
            slideUp(item, '.tjc-acc-item--text');
        } else {
            slideDown(item, '.tjc-acc-item--text');
        }
    }

    acc.addEventListener('click', ({target}) => {
        if (
            target.classList.contains('tjc-acc-item--title') ||
            target.parentElement.classList.contains('tjc-acc-item--title') ||
            target.parentElement.classList.contains('faq-post-item-svg-left') ||
            target.parentElement.classList.contains('faq-post-item-btn-left')
        ) {
            accLogic(target);
        }
    });

    acc.addEventListener('keyup', (e) => {
        if (e.keyCode === 13) {
            e.preventDefault();
            if (e.target.tagName === 'BUTTON' && e.target.classList.contains('tjc-acc-item--title')) return;
            if (
                e.target.parentElement.classList.contains('faq-post-item-svg-left') ||
                e.target.parentElement.classList.contains('faq-post-item-btn-left') ||
                e.target.classList.contains('tjc-acc-item--title')
            ) {
                accLogic(e.target);
            }
        }
    });
}

export default accordion;
